const safetySignals = require("./safetySignals");

// Keep the shared classifier CommonJS-compatible for the Node API while
// presenting statically discoverable named exports to the React build.
export const classifySafetyReference = safetySignals.classifySafetyReference;
export const detectCumulativeSafetyAdjacentSignal = safetySignals.detectCumulativeSafetyAdjacentSignal;
export const getSafetyContextState = safetySignals.getSafetyContextState;
export const getSafetyContextWindow = safetySignals.getSafetyContextWindow;
export const hasActivePersonalSafetySignal = safetySignals.hasActivePersonalSafetySignal;
export const hasExplicitSafetyDeescalation = safetySignals.hasExplicitSafetyDeescalation;
export const hasPracticalContextClarification = safetySignals.hasPracticalContextClarification;
